/*
 *  -----------------------------------------------------------------------
 *    <copyright file="admin-study-dataset-notes.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';

import ItemWrapper from 'views/components/core/item-wrapper';

import './admin-study-dashboard.scss';

// Show the dataset.notes for the currently selected dataset on the Study Dashboard - show nothing
// if no dataset is selected or exists

interface IStudyDatasetNotes {
    notes: string;
    dataSetNotesTitle: string;
}

const StudyDatasetNotes = ({ notes, dataSetNotesTitle }: IStudyDatasetNotes) => {
    if (!notes) return null;

    const createMarkup = (text: string) => {
        const newValue = text.replace(/[\n\r]/g, '<br/>');
        return { __html: newValue };
    };

    return (
        <ItemWrapper title={dataSetNotesTitle}>
            <div className="dataset-notes-wrapper">
                <div className="dataset-notes-wrapper__note" dangerouslySetInnerHTML={createMarkup(notes)} />
            </div>
        </ItemWrapper>
    );
};
export default StudyDatasetNotes;
